import { render, staticRenderFns } from "./charttable.vue?vue&type=template&id=c81cafca&scoped=true&"
import script from "./charttable.vue?vue&type=script&lang=js&"
export * from "./charttable.vue?vue&type=script&lang=js&"
import style0 from "./charttable.vue?vue&type=style&index=0&id=c81cafca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81cafca",
  null
  
)

export default component.exports